import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "dashboard_card_icon_menu_undo",
  "use": "dashboard_card_icon_menu_undo-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"dashboard_card_icon_menu_undo\"><path d=\"m8.985 13.563.019.046-4.444 1.82a.967.967 0 0 1-.857.073h-.001a.884.884 0 0 1-.477-.48l-1.896-4.626a.883.883 0 1 1 1.635-.67l.933 2.276a7.967 7.967 0 0 1 15.05 1.573.883.883 0 0 1-1.726.376 6.2 6.2 0 0 0-11.93-.675l3.062-1.256a.833.833 0 1 1 .632 1.543Zm0 0-4.448 1.822 4.448-1.822Z\" fill=\"#2D2C34\" stroke=\"#2D2C34\" stroke-width=\".1\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol